import React, { useState, useEffect, useContext } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import logo from "../../assets/logo_white.png";
import logoscrolled from "../../assets/logo_black.png";
import "./Navbar.css";
import { LanguageContext } from "../../context/LanguageContext";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Navbar = ({ Ip }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [home, setHome] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();



  const { isLang, changeLang } = useContext(LanguageContext);

  useEffect(() => {
    setHome(location.pathname === "/");
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const carouselHeight =
        document.querySelector(".carousel-container")?.offsetHeight || 100;
      setScrolled(window.scrollY > carouselHeight - 80);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goToSection = (selector) => {
    if (location.pathname !== "/") {
      navigate(`/${selector}`);
      return;
    }

    const element = document.querySelector(selector);
    if (element) {
      const navbarHeight = 80;
      const offsetTop =
        element.getBoundingClientRect().top +
        window.pageYOffset -
        navbarHeight;

      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }

    setMenuOpen(false);
    setActiveSubmenu(null);
  };


  const buttons = [
    {
      title: isLang === "AR" ? "الرئيسية" : "Accueil",
      action: () => goToSection("#home"),
    },
    {
      title: isLang === "AR" ? "السيرة الذاتية" : "Biographie",
      action: () => goToSection("#bio"),
    },
    {
      title: isLang === "AR" ? "السيرة" : "Histoire",
      action: () => goToSection("#history"),
    },
    {
      title: isLang === "AR" ? "أبرز المحطات" : "Éclats d’un Parcours",
      action: () => goToSection("#highlights"),
    },
  ];

  return (
    <div className={`navbarr ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container" style={{ direction: isLang == 'AR' ? "rtl" : "ltr" }}>
        <Link to="/" className="logo">
          <img
            src={scrolled ? logoscrolled : logo}
            alt="logo"
            style={{ width: "11rem" }}
            loading="lazy"
          />
        </Link>

        <div className="menuIcon" onClick={() => setMenuOpen(!menuOpen)}>
          <GiHamburgerMenu size={24} color={scrolled ? "#1b2b57" : "white"} />
        </div>

        <ul className={`navList ${menuOpen ? "open" : ""} ${scrolled ? "scrolled" : ""}`}>
          {buttons.map((item, index) => (
            <li key={index} className="navItem">
              <div className="navLink" onClick={item.action} style={{ cursor: "pointer" }}>
                {item.title}
              </div>
            </li>
          ))}

          {/* ⭐ LANGUAGE TOGGLE */}
          <li className="navItem">
            <button
              className="langButton"
              onClick={() => changeLang(isLang === "AR" ? "FR" : "AR")}
            >
              {isLang === "AR" ? "FR" : "AR"}
            </button>
          </li>
        </ul>

        {menuOpen && <div className="navbar-overlay" onClick={() => setMenuOpen(false)} />}
      </div>
    </div>
  );
};

export default Navbar;
